import { SectionTitle, Reveal } from "./Reveal";
import { FxGrid } from "./FxGrid";
import { useT } from "../lib/i18n";

const IMG = "/brand/fx.webp";

export const FxDeck = () => {
  const { t } = useT();
  return (
  <section id="fx-deck" data-testid="fx-deck-section" className="max-w-[1500px] mx-auto px-4 lg:px-10 py-24 lg:py-36">
    <SectionTitle index="03" kicker={t("fx.kicker")} title={<>{t("fx.title")}<span className="text-[#1FD1FF]">.</span></>} />
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
      <Reveal className="lg:col-span-4">
        <div className="relative aspect-[3/4] overflow-hidden [clip-path:polygon(0_0,100%_0,100%_100%,12%_100%,0_88%)]">
          <img src={IMG} alt="Ecualizador neón de DEEJAY T-REX" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_40%_30%,transparent_15%,rgba(9,10,15,0.9)_80%)]" />
          <p className="absolute bottom-6 left-8 right-6 text-[#E2E8F0] text-sm leading-relaxed">
            {t("fx.body")}
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8"><FxGrid /></Reveal>
    </div>
  </section>
  );
};
